import styled from "styled-components";

export const Content = styled.section`
  padding: 50px 20px;
  display: flex;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: cover;

  > div {
    max-width: 1240px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 52px;
    z-index: 0;

    > img {
      max-width: 500px;
      width: 100%;
    }

    @media (max-width: 1024px) {
      flex-direction: ${(props) =>
        props.$flexDirection === "column-reverse"
          ? "column-reverse"
          : "column"};

      > img {
        max-width: 50%;
      }
    }

    @media (max-width: 425px) {
      > img {
        max-width: 75%;
      }
    }
  }
`;
